module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "views"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('keep-alive', [_c('router-view')])])]), _vm._v(" "), (_vm.showNav) ? _c('bottomNav', {
    staticClass: "tab-nav",
    attrs: {
      "value": _vm.tabNav
    }
  }, [_c('navItem', {
    attrs: {
      "value": "#/",
      "title": "Intro",
      "icon": "fa fa-home"
    },
    nativeOn: {
      "click": function($event) {
        _vm.onTab('/')
      }
    }
  }), _vm._v(" "), _c('navItem', {
    attrs: {
      "value": "#/demo",
      "title": "Demo",
      "icon": "fa fa-tree"
    },
    nativeOn: {
      "click": function($event) {
        _vm.onTab('demo')
      }
    }
  }), _vm._v(" "), _c('navItem', {
    attrs: {
      "value": "#/coffee",
      "title": "Coffee",
      "icon": "fa fa-heart"
    },
    nativeOn: {
      "click": function($event) {
        _vm.onTab('coffee')
      }
    }
  }), _vm._v(" "), _c('navItem', {
    attrs: {
      "title": "Doc",
      "icon": "fa fa-book"
    },
    nativeOn: {
      "click": function($event) {
        _vm.onTab('doc')
      }
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-41570343!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 233
// module chunks = 0